<ivd-widget-support-chat [application]="application" [host]="host" [language]="language$ | async"
  [token]="token"></ivd-widget-support-chat>
